import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  MenuItem,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  TablePagination,
  IconButton,
  Dialog,
  Grid,
  Box,
  Chip,
  ListItemText,
  DialogActions,
  Checkbox,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Select,
  Button,
} from "@mui/material";
import axios from "../../Axiosinstance";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Header from "../Component/Header";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import NewCourse from "../Resourse/NewCourse";
import { toast, ToastContainer } from "react-toastify";
import { BsPencilFill, BsTrashFill } from "react-icons/bs";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// import { Box, Card, CardContent, Typography, MenuItem, Select,InputLabel,FormControl, IconButton, TextField, Grid, Button, Snackbar, Alert } from '@mui/material';

const CoursesList = () => {
  const [courses, setCourses] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openDialog, setOpenDialog] = useState(false);
  const [courseToDelete, setCourseToDelete] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [courseToEdit, setCourseToEdit] = useState({
    id: null,
    name: "",
    fee: "",
    categoryId: "", // Initialize categoryId with an empty string
    category: null,
    languages: [],
    courseAim: "",
    ps: "",
    entryRequirement: "",
    courseDuration: "",
    courseLocation: "",
    courseAttendanceRecord: "",
    assessmentCriteria: []
  });
  const [categories, setCategories] = useState([]);
  const [errors, setErrors] = useState({});

  const languageOptions = [
    "English",
    "Malay",
    "Tamil",
    "Hindi",
    "Telugu",
    "Bengali",
    "Mandarin",
    "Burmese",
    "Thai",
  ];

  useEffect(() => {
    fetchCourses();
    fetchCategories();
  }, [page, rowsPerPage]);

  const fetchCourses = async () => {
    try {
      const response = await axios.get("/wsq/courses");
      // Assuming the response is an array, map through courses to initialize categoryId properly
      const coursesWithCategoryId = response.data?.map(course => ({
        ...course,
        categoryId: course.category?.id || null, // Make sure categoryId is set correctly
      }));
      setCourses(coursesWithCategoryId);
    } catch (error) {
      console.error("Error fetching courses:", error);
      toast.error("Failed to load courses.");
    }
  };

  const handleCourseSelect = (selectedCourse) => {
    setCourseToEdit({
      ...selectedCourse,
      categoryId: selectedCourse.category?.id || null, // Ensure categoryId is set correctly
      category: selectedCourse.category, // Optionally set the full category object
    });
  };


  const fetchCategories = async () => {
    try {
      const response = await axios.get("/categories/findall");
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
      toast.error("Failed to load categories.");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/wsq/courses/${id}`);
      toast.success("Course deleted successfully");
      fetchCourses();
    } catch (error) {
      console.error("Error deleting course:", error);
      toast.error("Failed to delete course.");
    }
    handleCloseDialog();
  };

  const handleOpenDialog = (course) => {
    setCourseToDelete(course);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCourseToDelete(null);
  };

  const confirmDelete = () => {
    if (courseToDelete) {
      handleDelete(courseToDelete.id);
    }
  };

  const handleOpenEditDialog = (course) => {
    setCourseToEdit({
      ...course,
      languages: course.languages || [], // Ensure that languages is an empty array if not present
    });
    console.log(course.category.name);
    console.log(course);
    setOpenEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setCourseToEdit(null);
  };

  const validateFields = () => {
    const newErrors = {};
    if (!courseToEdit?.name) newErrors.name = "Course name is required.";
    if (!courseToEdit?.fee) newErrors.fee = "Course fee is required.";
    if (!courseToEdit?.languages || courseToEdit.languages.length === 0)
      newErrors.languages = "At least one language must be selected.";
    if (!courseToEdit?.categoryId)
      newErrors.categoryId = "Course category is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleEditCourse = async () => {
    if (!validateFields()) return; // Stop if validation fails

    try {
      await axios.put(`/wsq/courses/${courseToEdit.id}`, courseToEdit);
      toast.success("Course updated successfully");
      fetchCourses();
      handleCloseEditDialog();
    } catch (error) {
      console.error("Error updating course:", error);
      toast.error("Failed to update course.");
    }
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const filteredCourses = courses.filter((course) =>
    course.name.toLowerCase().includes(searchTerm)
  );

  // Function to add a new language
  const addLanguage = () => {
    setCourseToEdit((prev) => ({
      ...prev,
      languages: [...prev.languages, ""], // Add an empty string for a new language input
    }));
  };

  const handleLanguageChange = (event) => {
    const { value } = event.target;
    setCourseToEdit((prev) => ({
      ...prev,
      languages: typeof value === "string" ? value.split(",") : value,
    }));
  };

  const handleDeleteLanguage = (languageToDelete) => {
    setCourseToEdit((prev) => ({
      ...prev,
      languages: prev.languages.filter(
        (language) => language !== languageToDelete
      ),
    }));
  };

  const addAssessmentCriterion = () => {
    const newCriterion = {
      modeOfTrainingForAssessment: "",
      mode: "",
      method: "",
      duration: "",
      passingCriteria: "",
    };
    setCourseToEdit((prev) => ({
      ...prev,
      assessmentCriteria: [...prev.assessmentCriteria, newCriterion], // Add a new criterion object
    }));
  };

  const handleAssessmentCriterionChange = (index, field, value) => {
    const updatedCriteria = [...courseToEdit.assessmentCriteria];
    updatedCriteria[index][field] = value; // Update the specific field of the specific criterion
    setCourseToEdit((prev) => ({
      ...prev,
      assessmentCriteria: updatedCriteria,
    }));
  };

  // Function to remove an assessment criterion
  const removeAssessmentCriterion = (index) => {
    if (courseToEdit.assessmentCriteria.length > 1) {
      // Prevent removal if it's the last criterion
      const updatedCriteria = courseToEdit.assessmentCriteria.filter(
        (_, i) => i !== index
      );
      setCourseToEdit((prev) => ({
        ...prev,
        assessmentCriteria: updatedCriteria,
      }));
    } else {
      toast.warn("At least one assessment criterion must be present.");
    }
  };
  return (
    <Paper sx={{ maxWidth: 1000, margin: "auto" }}>
      <TextField
        label="Search Courses"
        variant="outlined"
        fullWidth
        margin="normal"
        value={searchTerm}
        onChange={handleSearch}
      />

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Fee</TableCell>
              <TableCell>Languages</TableCell>
              <TableCell>Category</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredCourses
              .slice((page - 1) * rowsPerPage, page * rowsPerPage)
              ?.map((course) => (
                <TableRow key={course.id}>
                  <TableCell>{course?.id}</TableCell>
                  <TableCell>{course?.name}</TableCell>
                  <TableCell>{course?.fee}</TableCell>
                  <TableCell>{course?.languages.join(", ")}</TableCell>
                  <TableCell>{course?.category.name}</TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="primary"
                      onClick={() => handleOpenEditDialog(course)}
                    >
                      <BsPencilFill />
                    </IconButton>
                    <IconButton
                      color="secondary"
                      onClick={() => handleOpenDialog(course)}
                    >
                      <BsTrashFill />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={filteredCourses.length}
        page={page - 1}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the course "{courseToDelete?.name}"?
            This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="error" onClick={handleCloseDialog}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={confirmDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openEditDialog} onClose={handleCloseEditDialog}>
        <DialogTitle>Edit Course</DialogTitle>
        <DialogContent>
          <TextField
            label="Course Name"
            fullWidth
            margin="normal"
            value={courseToEdit?.name || ""}
            onChange={(e) =>
              setCourseToEdit({ ...courseToEdit, name: e.target.value })
            }
            error={!!errors.name}
            helperText={errors.name}
          />

          <TextField
            label="Fee"
            fullWidth
            margin="normal"
            value={courseToEdit?.fee || ""}
            onChange={(e) =>
              setCourseToEdit({ ...courseToEdit, fee: e.target.value })
            }
            error={!!errors.fee}
            helperText={errors.fee}
          />

          {/* Render languages */}
          {/* {courseToEdit?.languages.map((language, index) => (
            <div key={index}>
              <TextField
                label={`Language ${index + 1}`}
                fullWidth
                margin="normal"
                value={language}
                onChange={(e) => handleLanguageChange(index, e.target.value)}
              />
              {index > 0 && ( // Show Remove button only if it's not the first language
                <Button onClick={() => removeLanguage(index)} color="secondary">
                  Remove
                </Button>
              )}
            </div>
          ))} */}
          {/* <Button onClick={addLanguage} color="primary">
            Add Language
          </Button> */}

          <TextField
            fullWidth
            sx={{ marginBottom: 2 }}
            select
            label="Languages"
            name="languages"
            value={courseToEdit?.languages || []}
            onChange={handleLanguageChange}
            SelectProps={{
              multiple: true,
              renderValue: (selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected?.map((value) => (
                    <Chip
                      key={value}
                      label={value}
                      //   onDelete={() => handleDeleteLanguage(value)}
                      sx={{ mr: 1 }}
                    />
                  ))}
                </Box>
              ),
            }}
            error={!!errors.languages}
            helperText={errors.languages}
          >
            {languageOptions?.map((language) => (
              <MenuItem key={language} value={language}>
                {language}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            fullWidth
            select
            label="Category"
            value={courseToEdit?.categoryId || ""} // Bind to categoryId, ensure it's initialized
            onChange={(e) => {
              const selectedCategory = categories.find(category => category.id === e.target.value); // Find selected category by ID
              setCourseToEdit({
                ...courseToEdit,
                categoryId: selectedCategory?.id, // Update categoryId in the state
                category: selectedCategory // Optionally update the category object as well
              });
            }}
          >
            {categories?.map((category) => (
              <MenuItem key={category.id} value={category.id}> {/* Set value to category.id */}
                {category.name} {/* Display category name */}
              </MenuItem>
            ))}
          </TextField>






          {/* New fields for additional course details */}
          {/* <TextField
            label="Course Aim"
            fullWidth
            margin="normal"
            value={courseToEdit?.courseAim || ""}
            onChange={(e) =>
              setCourseToEdit({ ...courseToEdit, courseAim: e.target.value })
            }
          /> */}

          <div style={{ marginBottom: "1rem" }}>
            <label
              style={{
                fontSize: "14px",
                color: "rgba(0, 0, 0, 0.54)",
                display: "block",
                marginBottom: "0.5rem",
              }}
            >
              Course Aim
            </label>
            <ReactQuill
              label="Course Aim"
              value={courseToEdit?.courseAim || ""}
              onChange={(value) => {
                if (courseToEdit?.courseAim !== value) {
                  setCourseToEdit((prev) => ({ ...prev, courseAim: value }));
                }
              }}
            />

          </div>

          {/* <TextField
            label="PS"
            fullWidth
            margin="normal"
            value={courseToEdit?.ps || ""}
            onChange={(e) =>
              setCourseToEdit({ ...courseToEdit, ps: e.target.value })
            }
          /> */}

          <div style={{ marginBottom: "1rem" }}>
            <label
              style={{
                fontSize: "14px",
                color: "rgba(0, 0, 0, 0.54)",
                display: "block",
                marginBottom: "0.5rem",
              }}
            >
              PS
            </label>
            <ReactQuill
              value={courseToEdit?.ps || ""}
              onChange={(value) =>
                setCourseToEdit({ ...courseToEdit, ps: value })
              }
            //   style={{
            //     border: "1px solid rgba(0, 0, 0, 0.23)",
            //     borderRadius: "4px",
            //     padding: "8px",
            //   }}
            />
          </div>

          {/* <TextField
            label="Entry Requirement"
            fullWidth
            margin="normal"
            value={courseToEdit?.entryRequirement || ""}
            onChange={(e) =>
              setCourseToEdit({
                ...courseToEdit,
                entryRequirement: e.target.value,
              })
            }
          /> */}

          <div style={{ marginBottom: "1rem" }}>
            <label
              style={{
                fontSize: "14px",
                color: "rgba(0, 0, 0, 0.54)",
                display: "block",
                marginBottom: "0.5rem",
              }}
            >
              Entry Requirement
            </label>
            <ReactQuill
              label="Entry Requirement"
              value={courseToEdit?.entryRequirement || ""}
              onChange={(value) =>
                setCourseToEdit({
                  ...courseToEdit,
                  entryRequirement: value,
                })
              }
            />
          </div>

          <TextField
            label="Course Duration"
            fullWidth
            margin="normal"
            value={courseToEdit?.courseDuration || ""}
            onChange={(e) =>
              setCourseToEdit({
                ...courseToEdit,
                courseDuration: e.target.value,
              })
            }
          />
          <TextField
            label="Course Location"
            fullWidth
            margin="normal"
            value={courseToEdit?.courseLocation || ""}
            onChange={(e) =>
              setCourseToEdit({
                ...courseToEdit,
                courseLocation: e.target.value,
              })
            }
          />
          <TextField
            label="Course Attendance Record"
            fullWidth
            margin="normal"
            value={courseToEdit?.courseAttendanceRecord || ""}
            onChange={(e) =>
              setCourseToEdit({
                ...courseToEdit,
                courseAttendanceRecord: e.target.value,
              })
            }
          />

          {/* Render assessment criteria */}
          <div>
            <h3>Assessment Criteria</h3>
            {courseToEdit?.assessmentCriteria?.map((criterion, index) => (
              <div key={index} style={{ marginBottom: "1rem" }}>
                <TextField
                  label="Mode of Training for Assessment"
                  fullWidth
                  margin="normal"
                  value={criterion.modeOfTrainingForAssessment}
                  onChange={(e) =>
                    handleAssessmentCriterionChange(
                      index,
                      "modeOfTrainingForAssessment",
                      e.target.value
                    )
                  }
                />
                <TextField
                  label="Mode"
                  fullWidth
                  margin="normal"
                  value={criterion.mode}
                  onChange={(e) =>
                    handleAssessmentCriterionChange(
                      index,
                      "mode",
                      e.target.value
                    )
                  }
                />
                <TextField
                  label="Method"
                  fullWidth
                  margin="normal"
                  value={criterion.method}
                  onChange={(e) =>
                    handleAssessmentCriterionChange(
                      index,
                      "method",
                      e.target.value
                    )
                  }
                />
                <TextField
                  label="Duration"
                  fullWidth
                  margin="normal"
                  value={criterion.duration}
                  onChange={(e) =>
                    handleAssessmentCriterionChange(
                      index,
                      "duration",
                      e.target.value
                    )
                  }
                />
                <TextField
                  label="Passing Criteria"
                  fullWidth
                  margin="normal"
                  value={criterion.passingCriteria}
                  onChange={(e) =>
                    handleAssessmentCriterionChange(
                      index,
                      "passingCriteria",
                      e.target.value
                    )
                  }
                />
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => removeAssessmentCriterion(index)}
                >
                  Remove
                </Button>
              </div>
            ))}
            <Button
              variant="contained"
              color="primary"
              onClick={addAssessmentCriterion}
            >
              Add Assessment Criterion
            </Button>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={handleCloseEditDialog}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleEditCourse}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

const New = () => {
  const [tabValue, setTabValue] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleFormSubmit = () => {
    // Change to tab number 0 and show toast
    setTabValue(0);
    //   toast.success('Course added successfully!');
  };

  return (
    <div>
      <Header />
      <br />
      <div className="d-flex justify-content-center mt-4">
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="Tabs"
          variant="fullWidth"
          sx={{
            borderRadius: 10,
            display: "flex",
            justifyContent: "center",
            "& button": {
              display: "flex",
              justifyContent: "center",
            },
            "& button:hover": {
              backgroundColor: "#eee",
            },
            "& button:active": {
              backgroundColor: "#ddd",
            },
            "& button.Mui-selected": {
              backgroundColor: "#007bff",
              color: "#fff",
            },
            "& .MuiTabs-indicator": {
              display: "none",
            },
            ...(isMobile && {
              flexDirection: "column",
              "& button": {
                width: "100%",
              },
            }),
          }}
        >
          <Tab label="Courses" sx={{ minWidth: isMobile ? "50%" : "600px" }} />
          <Tab
            label="New Course"
            sx={{ minWidth: isMobile ? "50%" : "600px" }}
          />
        </Tabs>
      </div>
      <div>
        {tabValue === 0 && <CoursesList />}
        {tabValue === 1 && <NewCourse onFormSubmit={handleFormSubmit} />}
      </div>

      {/* Toast Notification */}
      <ToastContainer />
    </div>
  );
};

export default New;
